<template>
  <!-- COMPACT MODE (for list) -->
  <div
    v-if="!detailMode"
    class="px-3 flex h-full items-center ripple cursor-pointer hover:bg-gray-50 rounded-xl transition-colors"
    @click="
      $bus.emit(
        $constants.EVENTS.TRANSACTIONS.DETAILS_REQUESTED,
        $attrs.item
      )
    "
  >
    <div class="flex md:grid grid-cols-3 gap-2 items-center w-full">
      <!-- CLIENT IDENTITÉ -->
      <div class="col-span-1 flex gap-3 items-center">
        <!-- Avatar -->
        <div
          class="w-12 h-12 min-w-12 rounded-xl overflow-hidden flex items-center justify-center bg-gradient-to-br from-primary-500 to-primary-600 text-white font-semibold text-lg"
        >
          <img
            v-if="$attrs.item?.country?.localLogoUrl"
            :src="$attrs.item.country.localLogoUrl"
            :alt="$attrs.item.country.name"
            class="w-full h-full object-cover"
          />
          <span v-else>
            {{ ($attrs.item?.firstName || '')?.charAt(0) }}{{ ($attrs.item?.lastName || '')?.charAt(0) }}
          </span>
        </div>

        <div class="overflow-x-hidden whitespace-nowrap">
          <div class="font-medium text-gray-900 truncate">
            {{ $attrs.item?.firstName }} {{ $attrs.item?.lastName }}
          </div>
          <div class="text-sm text-gray-500 truncate mt-0.5">
            {{ $attrs.item?.email }}
          </div>
        </div>
      </div>

      <!-- CONTACT -->
      <div class="hidden md:flex flex-col overflow-x-hidden">
        <div class="font-medium text-gray-900 truncate">
          +{{ $attrs.item?.country?.callingCode }} {{ $attrs.item?.phoneNumber }}
        </div>
        <div class="text-sm text-gray-500 mt-0.5">
          {{ $attrs.item?.country?.name }}
        </div>
      </div>

      <!-- MÉTADONNÉES -->
      <div class="ml-auto text-end items-end flex flex-col">
        <div class="text-xs text-gray-500">ID</div>
        <div class="font-mono text-sm text-gray-700">
          {{ $attrs.item?.id?.slice(0, 8) }}...
        </div>
        <div class="text-xs text-gray-500 mt-1">
          {{ $attrs.item?.creationDate || '' }}
        </div>
      </div>
    </div>
  </div>

  <!-- DETAIL MODE (for detail page) -->
  <div v-else class="space-y-6">
    <!-- HEADER CARD -->
    <div class="bg-white rounded-2xl p-6 shadow-sm">
      <div class="flex items-start gap-6">
        <!-- LARGE AVATAR -->
        <div
          class="w-24 h-24 rounded-2xl overflow-hidden flex items-center justify-center bg-gradient-to-br from-primary-500 to-primary-600 text-white font-bold text-3xl flex-shrink-0"
        >
          <img
            v-if="$attrs.item?.country?.localLogoUrl"
            :src="$attrs.item.country.localLogoUrl"
            :alt="$attrs.item.country.name"
            class="w-full h-full object-cover"
          />
          <span v-else>
            {{ ($attrs.item?.firstName || '')?.charAt(0) }}{{ ($attrs.item?.lastName || '')?.charAt(0) }}
          </span>
        </div>

        <!-- INFO -->
        <div class="flex-1">
          <h1 class="text-2xl font-bold text-gray-900">
            {{ $attrs.item?.firstName }} {{ $attrs.item?.lastName }}
          </h1>
          <p class="text-gray-500 mt-1">{{ $attrs.item?.email }}</p>

          <div class="flex flex-wrap gap-4 mt-4">
            <div class="flex items-center gap-2 text-gray-700">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 8V5z" />
              </svg>
              <span class="font-medium">+{{ $attrs.item?.country?.callingCode }} {{ $attrs.item?.phoneNumber }}</span>
            </div>
            <div v-if="$attrs.item?.country" class="flex items-center gap-2 text-gray-700">
              <img
                :src="$attrs.item.country.localLogoUrl"
                :alt="$attrs.item.country.name"
                class="w-5 h-5 rounded-full object-cover"
              />
              <span>{{ $attrs.item?.country?.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- METADATA -->
      <div class="mt-6 pt-6 border-t border-gray-100 grid grid-cols-2 gap-4">
        <div>
          <div class="text-xs text-gray-500 uppercase">Client ID</div>
          <div class="font-mono text-sm text-gray-900 mt-1">{{ $attrs.item?.id }}</div>
        </div>
        <div>
          <div class="text-xs text-gray-500 uppercase">Membre depuis</div>
          <div class="text-sm text-gray-900 mt-1">{{ $attrs.item?.creationDate || '-' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerItem',
  props: {
    detailMode: {
      type: Boolean,
      default: false
    }
  }
};
</script>
